/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 体位
 */
export type FindEmsContactPositionEnum =
  (typeof FindEmsContactPositionEnum)[keyof typeof FindEmsContactPositionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactPositionEnum = {
  SUPINE: 'SUPINE',
  PRONE: 'PRONE',
  LATERAL: 'LATERAL',
  LATERAL_RIGHT: 'LATERAL_RIGHT',
  LATERAL_LEFT: 'LATERAL_LEFT',
  SITTING: 'SITTING',
  SEMI_SITTING: 'SEMI_SITTING',
  KNEE_FLEXION: 'KNEE_FLEXION',
  SHOCK: 'SHOCK',
  STANDING: 'STANDING',
  OTHER: 'OTHER',
} as const;
